import PricingUpload from 'routes/PricingUpload/components/PricingUpload';

export default PricingUpload;
